import pdfMake from 'pdfmake';
import pdfFonts from '../assets/custom-fonts';
import dayjs from 'dayjs';
//import { DataServices } from '../services/DataServices';

export const daySchedulerReport = {
  async ReportExport(ExaminerDataList, Date) {
    //console.log('xe : ', ExaminerDataList);
    //let ex = 10;
    pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
    pdfMake.fonts = {
      // download default Roboto font from cdnjs.com
      Roboto: {
        normal:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics:
          'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
      },
      THSarabunNew: {
        // 3. set Kanit font
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew Bold.ttf',
      },
      iconic: {
        normal: 'iconic.ttf',
      },
    };

    const docDefinition = {
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 13,
      },
      pageSize: 'A4',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 20, 20, 20],
      pageOrientation: 'portrait',
      content: [
        {
          text: 'วาระผู้บริหารกรมการข้าว',
          style: 'superHeader',
          alignment: 'center',
        },
        {
          text: 'วันที่ ' + Date,
          style: 'header',
          alignment: 'center',
        },
        await this.table(ExaminerDataList, [
          'board',
          'time',
          'description',
        ]),
      ],
      styles: {
        superHeader: {
          fontSize: 23,
          bold: true,
        },
        header: {
          fontSize: 18,
          bold: true,
        },
        subheader: {
          fontSize: 15,
          bold: true,
        },
        quote: {
          italics: true,
        },
        small: {
          fontSize: 8,
        },
        iconx: {
          font: 'iconic',
        },
      },
    };

    var win = window.open('', '_blank');
    pdfMake.createPdf(docDefinition).open({}, win);

    /*var dd = {
      defaultStyle: {
        font: 'THSarabunNew',
        fontSize: 13,
      },
      pageSize: 'A4',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 20, 20, 20],
      pageOrientation: 'portrait',
      content: [
        { text: 'วาระผู้บริหารกรมการข้าว', style: 'header' },
        await this.table(ExaminerDataList, [
          'board',
          'time',
          'description',
        ]),
      ],
    };

    var win = window.open('', '_blank');
    pdfMake.createPdf(dd).open({}, win);*/
  },
  async buildTableBody(data, columns, header) {
    var body = [];
    body.push(header);
    data.forEach(function (row) {
      var dataRow = [];
      //console.log('row : ', row);
      columns.forEach(function (column) {
        if (
          row[column] == '' ||
          row[column] == undefined ||
          row[column] == null
        ) {
          dataRow.push('');
        } else {
          dataRow.push(row[column].toString().replaceAll('\n', ''));
        }
      });
      if (row.desLength > 1 && row.no == 1) {
        dataRow[0] = {
          rowSpan: parseInt(row.desLength),
          text: row.board,
        };
      } else if (row.desLength > 1 && row.no > 1) {
        dataRow[0] = '';
      } else {
        //
      }
      //console.log('xr: ', dataRow);
      body.push(dataRow);
    });
    //console.log('body : ', body);
    return body;
  },
  async table(data, columns) {
    var y = ['ผู้บริหาร', 'เวลา', 'วาระงาน'];
    var ccd = await this.buildTableBody(data, columns, y);
    var x = [
      {
        table: {
          widths: [50, 'auto', '*'],
          body: ccd,
        },
        //pageBreak: 'after',
      },
    ];
    return x;
  },
  ReplaceTagF(text1) {
    var Replacetag = text1.replace('\n', '');
    //console.log('Replacetag : ', Replacetag);
    return Replacetag;
  },
  DateFormat(date) {
    if (!date) {
      return `-`;
    }
    return dayjs(date).add(543, 'years').format('DD/MM/YYYY');
  },
  yearCal(date) {
    if (!date) {
      return `-`;
    }
    return dayjs().diff(date, 'year');
  },
  //backup
  /*async buildTableBody(data, columns, header) {
    var body = [];
    body.push(header);
    data.forEach(function (row) {
      var dataRow = [];
      columns.forEach(function (column) {
        if (
          row[column] == '' ||
          row[column] == undefined ||
          row[column] == null
        ) {
          dataRow.push('');
        } else {
          dataRow.push(row[column].toString().replaceAll('\n', ''));
        }
      }); 
      console.log('xr: ', dataRow);
      body.push(dataRow);
    });s
    console.log('body : ', body);
    return body;
  },*/
};
